import React, { useState, useEffect } from "react";
import { useColorSort } from "./hooks/useColorSort";
import TubeStack       from "./components/TubeStack";
import Controls        from "./components/Controls";
import Overlay         from "./components/Overlay";
import type { TubeConfig } from "./core/types";
import bgImage from "./assets/potion_workshop.png";

interface ColorSortAppProps {
  initialTubes: TubeConfig[];
  undoEnabled?: boolean;
  resetEnabled?: boolean;
  onFinish: (data: { events: any[] }) => void;
}

export default function ColorSortApp({
  initialTubes,
  undoEnabled = true,
  resetEnabled = true,
  onFinish,
}: ColorSortAppProps) {
  const {
    tubes,
    pour,
    undo,
    reset,
    canUndo,
    canReset,
    moves,
    isSolved,
    events,
  } = useColorSort(initialTubes, undoEnabled, resetEnabled);

  // Responsive tube sizing...
  const [tubeSize, setTubeSize] = useState({
    width: 45,
    height: 140,
    scale: 1,
  });
  useEffect(() => {
    const DEFAULT_H = 140;
    const aspect = 45 / DEFAULT_H;
    const updateSize = () => {
      const h = window.innerHeight * 0.2;
      const scale = h / DEFAULT_H;
      setTubeSize({ width: h * aspect, height: h, scale });
    };
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const [overlayOpen, setOverlayOpen] = useState(false);
  useEffect(() => {
    if (isSolved) setOverlayOpen(true);
  }, [isSolved]);

  const handleClose = () => {
    console.log("=== Full action log ===");
    events.forEach((e) =>
      console.log(
        `${new Date(e.timestamp).toLocaleTimeString()}: ${e.description}`
      )
    );
    setOverlayOpen(false);
    onFinish({ events });
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundImage: `url(${bgImage})`,
        backgroundSize:   "cover",
        backgroundPosition: "center",
        backgroundRepeat:  "no-repeat",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div 
      className="app-wrapper"
      style={{
        maxWidth: "40%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}>
        <div 
        className="game-container"
        style={{
          display: "inline-block",
          textAlign: "center",
          background: "rgba(255,255,255,0.6)",
          backdropFilter: "blur(10px)",
          padding: "2rem",
          borderRadius: "12px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
        }}
              >
          <h1
            className="ws-header"
            style={{
              display: 'inline-block',
              marginBottom: '1.2rem',
              maxWidth: '90%',
              fontSize: 20 * tubeSize.scale,
              wordBreak: 'break-word',
            }}
                    >
            Pour colors between the tubes until each tube contains only one color!
          </h1>
  
          <TubeStack
            tubes={tubes}
            onPour={pour}
            tubeWidth={tubeSize.width}
            tubeHeight={tubeSize.height}
          />
  
          <Controls
            undoEnabled={canUndo}
            resetEnabled={canReset}
            onUndo={undo}
            onReset={reset}
            moves={moves}
            scale={tubeSize.scale}
          />
  
          {overlayOpen && <Overlay onClose={handleClose} />}
        </div>
      </div>
    </div>
  );
}
